import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import vMultiselectListbox from 'vue-multiselect-listbox'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('v-multiselect-listbox', vMultiselectListbox)
